import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-toggle-row',
  templateUrl: './toggle-row.component.html',
  styleUrls: ['./toggle-row.component.css'],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleRowComponent),
      multi: true
    }
  ]
})
export class ToggleRowComponent implements ControlValueAccessor {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() icon = '';
  @Input() accent = '#2f8def';
  /** Locked-on look: switch is always on and cannot be turned off. */
  @Input() mandatory = false;
  @Input() disabled = false;
  /** When false, the row is a stub: toggling emits stubToggled and does not commit. */
  @Input() committable = true;
  @Output() stubToggled = new EventEmitter<void>();
  @Output() changed = new EventEmitter<boolean>();

  value = false;

  private onChange: (value: boolean) => void = () => {};
  private onTouched: () => void = () => {};

  get checked(): boolean {
    return this.mandatory ? true : this.value;
  }

  toggle(): void {
    if (this.disabled || this.mandatory) {
      return;
    }
    if (!this.committable) {
      this.stubToggled.emit();
      return;
    }
    this.value = !this.value;
    this.onChange(this.value);
    this.onTouched();
    this.changed.emit(this.value);
  }

  get iconTileStyle(): { [key: string]: string } {
    return { color: this.accent, background: this.accent + '1a' };
  }

  get trackStyle(): { [key: string]: string } {
    return this.checked ? { background: this.accent } : {};
  }

  writeValue(value: boolean): void {
    this.value = !!value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
